import { fetchAudioEffect } from 'app/store/Releases/effects';
import { useAppDispatch, useAppSelector } from 'app/store';
import { getReleaseVersion } from 'app/store/Releases/selectors';
import { useEffect, useState } from 'react';
import { Audio } from 'types/audio';
import { useIsMounted } from 'app/utils/hooks';

export const useFetchPrimaryAudio = () => {
  const dispatch = useAppDispatch();
  const isMounted = useIsMounted();
  const releaseVersion = useAppSelector(getReleaseVersion);
  const [primaryAudio, setPrimaryAudio] = useState<Audio | null>(null);
  const [primaryAudioFetching, setPrimaryAudioFetching] = useState(true);

  const fetchPrimaryAudio = async () => {
    if (
      !releaseVersion?.metadata.primaryAudioGuid ||
      releaseVersion?.metadata.primaryAudioGuid === primaryAudio?.guid
    )
      return;
    try {
      setPrimaryAudioFetching(true);
      const audio = await dispatch(
        fetchAudioEffect({
          guid: releaseVersion.metadata.primaryAudioGuid,
          parentGuid: releaseVersion.metadata.guid,
        })
      ).unwrap();
      setPrimaryAudio(audio);
    } catch {
      // proceed
    } finally {
      if (isMounted()) {
        setPrimaryAudioFetching(false);
      }
    }
  };

  useEffect(() => {
    if (releaseVersion?.metadata.primaryAudioGuid) {
      fetchPrimaryAudio();
    } else {
      setPrimaryAudioFetching(false);
      setPrimaryAudio(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseVersion?.metadata.primaryAudioGuid, releaseVersion]);

  return {
    primaryAudioFetching,
    setPrimaryAudioFetching,
    primaryAudio,
    setPrimaryAudio,
  };
};
